export default class BookingForm {
  constructor(formElement) {
    this.form = formElement;
    this.arrivalInput = formElement.querySelector('#arrival');
    this.departureInput = formElement.querySelector('#departure');
    this.childrenSelect = formElement.querySelector('#children');

    if (!this.form || !this.childrenSelect) {
      return;
    }

    this.agesFieldset = this.createAgesFieldset();
    this.agesContent = this.agesFieldset.querySelector('.travels-booking-form__form-fieldset__content');
    this.insertAgesFieldset();

    this.bindEvents();
    this.renderAgeSelects();
  }

  bindEvents() {
    this.form.addEventListener('submit', (event) => this.handleSubmit(event));
    this.childrenSelect.addEventListener('change', () => this.renderAgeSelects());
    window.addEventListener('pageshow', () => this.renderAgeSelects());
  }

  createAgesFieldset() {
    const fieldset = document.createElement('fieldset');
    fieldset.className = 'travels-booking-form__form-fieldset travels-booking-form__ages-fieldset';

    const legend = document.createElement('legend');
    legend.textContent = 'Alter der Kinder';
    fieldset.appendChild(legend);

    const content = document.createElement('div');
    content.className = 'travels-booking-form__form-fieldset__content';
    fieldset.appendChild(content);

    return fieldset;
  }

  insertAgesFieldset() {
    const participantsFieldset = this.childrenSelect.closest('fieldset');
    if (participantsFieldset && participantsFieldset.parentNode) {
      participantsFieldset.parentNode.insertBefore(this.agesFieldset, participantsFieldset.nextSibling);
    } else {
      this.form.appendChild(this.agesFieldset);
    }
  }

  renderAgeSelects() {
    const count = parseInt(this.childrenSelect.value, 10) || 0;
    this.agesContent.innerHTML = '';

    if (count === 0) {
      this.agesFieldset.hidden = true;
      return;
    }

    this.agesFieldset.hidden = false;
    for (let i = 1; i <= count; i++) {
      this.agesContent.appendChild(this.buildAgeField(i));
    }
  }

  buildAgeField(index) {
    const field = document.createElement('div');
    field.className = 'travels-booking-form__field';

    const selectId = `age-child-${index}`;

    const label = document.createElement('label');
    label.setAttribute('for', selectId);
    label.textContent = `Alter Kind ${index}:`;
    field.appendChild(label);

    const selectReplace = document.createElement('div');
    selectReplace.className = 'select-replace';

    const select = document.createElement('select');
    select.id = selectId;
    select.className = 'travels-booking-form__age';
    select.required = true;

    const placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.disabled = true;
    placeholder.selected = true;
    placeholder.textContent = 'Bitte wählen';
    select.appendChild(placeholder);

    for (let age = 3; age <= 17; age++) {
      const option = document.createElement('option');
      option.value = String(age);
      option.textContent = age === 1 ? '1 Jahr' : `${age} Jahre`;
      select.appendChild(option);
    }

    const icon = document.createElement('div');
    icon.className = 'select-replace__icon';

    selectReplace.appendChild(select);
    selectReplace.appendChild(icon);
    field.appendChild(selectReplace);

    return field;
  }

  formatDate(iso) {
    if (!iso) {
      return '';
    }
    const parts = iso.split('-');
    if (parts.length !== 3) {
      return iso;
    }
    const [year, month, day] = parts;
    return `${day}.${month}.${year}`;
  }

  handleSubmit(event) {
    event.preventDefault();

    const params = new URLSearchParams();
    const formData = new FormData(this.form);

    for (const [name, value] of formData.entries()) {
      if (name === 'arrival' || name === 'departure') {
        params.append(name, this.formatDate(value));
      } else {
        params.append(name, value);
      }
    }

    const ageSelects = this.agesContent.querySelectorAll('.travels-booking-form__age');
    if (ageSelects.length > 0) {
      const ages = Array.from(ageSelects).map((select) => select.value).join(',');
      params.append('ages', ages);
    }

    const action = this.form.getAttribute('action') || '';
    const url = `${action}?${params.toString()}`;

    // External booking always opens in a new tab (mirrors the form's target="_blank").
    // Note: do NOT pass 'noopener' as a window feature here. Per spec, window.open()
    // then always returns null, which would wrongly trigger the popup-blocked fallback
    // and load the booking URL in the current tab as well.
    const target = this.form.getAttribute('target') || '_blank';
    const newWindow = window.open(url, target);
    if (newWindow) {
      newWindow.opener = null;
    } else {
      // Popup blocked: fall back to navigating in the current tab.
      window.location.assign(url);
    }
  }
}
